module.exports = __webpack_public_path__ + "img/racecourse-scottsville-turf-inner-2000.2e6fa19e.svg";